import React from 'react';

export const RacePerformance = () => {
  return (
    <section className="laprf-race-performance">
      <div className="laprf-race-performance-text">
        <h2 className="laprf-race-performance-title">Race-Proven Excellence</h2>
        <div className="laprf-race-performance-line">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="2"
            viewBox="0 0 100 2"
            preserveAspectRatio="none"
          >
            <path d="M0 1H100" stroke="url(#paint0_linear_900_2792)" />
            <defs>
              <linearGradient
                id="paint0_linear_900_2792"
                x1="0"
                y1="1.5"
                x2="100"
                y2="1.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.509" stopColor="#FF2238" />
                <stop offset="1" stopColor="#FF2238" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <p className="laprf-race-performance-description">
          Trusted in major events like the 2017 MultiGP International Open and
          USA Championships, the LapRF 8-Way is relied upon by race director Joe
          Scully for global competitions. When accuracy and reliability matter,
          this system delivers.
        </p>
      </div>
    </section>
  );
};
